import { network } from 'services/network';

export const setReport = (params) => {
    return network.post('api/bo/reporting/setReport', params).then((response) => {
        return response.data;
    });
};
